import * as Yup from 'yup';

export const addressSchemas = Yup.object({
  fullname: Yup.string().required('โปรดระบุชื่อ - นามสกุลให้ถูกต้อง'),
  phone: Yup.string()
    .matches(/^[!0]/, 'โปรดระบุเบอร์โทรศัพท์ให้ถูกต้อง')
    .required('โปรดระบุเบอรโทรศัพท์ให้ถูกต้อง'),
  address: Yup.string().required('โปรดระบุที่อยู่ให้ถูกต้อง'),
  alley: Yup.string().required('โปรดระบุซอยให้ถูกต้อง'),
  street: Yup.string().required('โปรดระบุถนนให้ถูกต้อง'),
  province: Yup.string().required('โปรดระบุจังหวัดให้ถูกต้อง'),
  district: Yup.string().required('โปรดระบุอำเภอให้ถูกต้อง'),
  subdistrict: Yup.string().required('โปรดระบุตำบลให้ถูกต้อง'),
  zipcode: Yup.string()
    .min(5, 'โปรดระบุรหัสไปรษณีย์อย่างน้อย 5 ตัว')
    .required('โปรดระบุรหัสไปรษณีย์ให้ถูกต้อง'),
});
